import { Draft, StoreFont } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { getAppearance } from '@/model/draft/getAppearance';
import { getPrintTypesForPrintArea } from '@/model/printType/getPrintTypesForPrintArea';
import { getPrintAreaForNewConfiguration } from './getPrintAreaForNewConfiguration';

export const getPrintTypeForFontOnDraft = (draft: Draft, font: StoreFont) => {
  const printArea = assertDefined(getPrintAreaForNewConfiguration(draft));
  const printTypes = getPrintTypesForPrintArea(printArea, getAppearance(draft))
    .filter((pt) => font.printTypeIds.includes(pt.id))
    .sort((a, b) => a.weight - b.weight);
  return printTypes[0];
};
